import Ext from 'Ext'
import SelectorPanelWithApplyButtonHelper from './selectorControls/at_selector_panel_with_apply_button_object'
import SharedUserButtonMenu from './selectorControls/at_shared_user_button_menu'
import HierarchySelectorDropdownButton from './selectorControls/at_hierarchy_selector_dropdown_button'
import messageResource from '../messageResource'
import User from '../store/User'
import TwoLevelSelection from './selectorControls/two_level_selection'
import ShareReportsSelectorUsersPanel from '../reports/ShareReportsSelectorUsersPanel'
import {transformListToGroups} from '../util/groupUtils'
import {SHARE_REPORT_SELECTOR_PANEL_HEIGHT} from './constants'

export default class ShareReportUserSelectorButton {

    constructor(config) {
        this.containerId = config.selectorId

        this.predefinedUserSelection = {}
        const reportConfigUserSelection = config.userSelection

        this.settedWithPredefinedValues = !!reportConfigUserSelection
        this.predefinedUserSelection.selectedUsers = reportConfigUserSelection && reportConfigUserSelection.selectedUsers ? reportConfigUserSelection.selectedUsers : []
        this.predefinedUserSelection.selectedGroups = reportConfigUserSelection && reportConfigUserSelection.selectedGroups ? reportConfigUserSelection.selectedGroups : []
        this.predefinedUserSelection.showDisabled = reportConfigUserSelection ? !!reportConfigUserSelection.showDisabled : true
        this.predefinedUserSelection.groupType = reportConfigUserSelection ? reportConfigUserSelection.groupType : null
        this.predefinedUserSelection.includeUserTeamOnly = reportConfigUserSelection ? reportConfigUserSelection.includeUserTeamOnly : false

        let params = config.report_name ? {collapsedCookiesKey: config.report_name} : {}
        const panelConstructor = ShareReportsSelectorUsersPanel
        const applyButtonExtension = SelectorPanelWithApplyButtonHelper.getApplyButtonExtension(panelConstructor)
        applyButtonExtension.closeButtonLabelKey = 'saved_reports.common.copy_to'
        Ext.apply(params, applyButtonExtension)

        this.panel = new panelConstructor(params)

        this.panel.setPredefinedState(this.convertPredefinedStateFromSelection(this.predefinedUserSelection))
        this.userSelectorMenu = new SharedUserButtonMenu({panel: this.panel})

        this._createUserButton(this.containerId, this.userSelectorMenu, SHARE_REPORT_SELECTOR_PANEL_HEIGHT)

        this.panel.closeButton.on('click', () => {
            if (config.changeCallback && this.panel.validateIsUsersSelected()) {
                config.changeCallback()
                this.panel.resetState(true)
            }
        })
    }

    _createUserButton(containerId, userSelectorMenu, selectorPanelHeight) {
        this.chooseUserButton = new HierarchySelectorDropdownButton({
            labelCls: 'hierarchySelectorButton',
            renderTo: containerId,
            menu: userSelectorMenu,
            selectorPanelHeight: selectorPanelHeight
        })
        this.chooseUserButton.setText(messageResource.getMessage('users_selector.reports.loading'))
        this.chooseUserButton.setEnabled(false)
    }

    updateButton() {
        this.chooseUserButton.updateButton()
    }

    getButton() {
        return this.chooseUserButton
    }

    setInitialValueFromCurrent() {
        this.panel.setInitialValueFromCurrent()
    }

    updateSelector(users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, manageableUsersIds, showTeamOnly, loggedInUserNotInTeam) {
        const convertedUserGroups = (userGroups == null) ? null : transformListToGroups(userGroups)
        const convertedTimeZoneGroups = (timeZoneGroups == null) ? null : transformListToGroups(timeZoneGroups)
        this.initializeData(
            userGroupsEnabled,
            timeZoneGroupsEnabled,
            this._convertUserInfoToJsUsers(users),
            manageableUsersIds,
            convertedUserGroups,
            convertedTimeZoneGroups,
            showTeamOnly,
            loggedInUserNotInTeam,
        )
    }

    initializeData(userGroupsEnabled, timeZoneGroupsEnabled, users, manageableUsersIds, userGroups, timeZoneGroups, showTeamOnly, loggedInUserNotInTeam) {
        this.panelWasConstructing = true
        this.panel.initialize({
            userGroupsEnabled,
            timeZoneGroupsEnabled,
            users,
            manageableUsersIds,
            userGroups,
            timeZoneGroups,
            showTeamOnly,
            loggedInUserNotInTeam,
        })
        this.chooseUserButton.setEnabled(true)
    }

    getSelectedUsers() {
        return this.panel.getOnlyUsersSelection()
    }

    setSelection(userSelection) {
        const predefinedState = this.convertPredefinedStateFromSelection(userSelection)
        this.panel.setPredefinedState(predefinedState)
        if (this.panelWasConstructing) {
            this.panel.loadState(predefinedState)
        }
    }

    _convertUserInfoToJsUsers(userbeans) {
        const users = []
        for (let i = 0; i < userbeans.length; ++i) {
            const u = userbeans[i]
            users.push(new User(u.id, u.firstName, u.lastName, u.middleName, u.username, u.enabled, undefined, u.userGroupId, u.timeZoneGroupId))
        }
        return users
    }

    validateIsUserSelected() {
        return (this.settedWithPredefinedValues || this.panel.isAlreadyShown()) ? this.panel.validateIsUsersSelected() :
               this.predefinedUserSelection.allUsers ||
               this.predefinedUserSelection.selectedUsers !== [] ||
               this.predefinedUserSelection.selectedGroups !== []
    }

    convertPredefinedStateFromSelection(selection) {
        return {
            selection: selection.allUsers ? TwoLevelSelection.emptySelection() : new TwoLevelSelection(selection.selectedGroups, selection.selectedUsers),
            optionValue: selection.allUsers,
            showInactive: selection.showDisabled,
            groupType: selection.groupType
        }
    }

    isStateChanged() {
        return this.panel.isStateChanged()
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/ShareReportUserSelectorButton.js